
"use strict";

export const Exceptions = {
    NullPointer: "NullPointer",
    IllegalArgument: "IllegalArgument",
    IllegalState: "IllegalState",
    IndexOutOfBounds: "IndexOutOfBounds",
	OutOfRange: "OutOfRange",
    ChildNotAvailable: "ChildNotAvailable"
};
